import type { BlockTemplateData } from '@plone-collective/volto-editortemplates/types';
import type { BlockConfigBase, JSONSchema } from '@plone/types';
import type { IntlShape } from 'react-intl';

const TemplateSelectorBlockSchema = ({
  data,
  intl,
}: {
  data: BlockTemplateData;
  intl: IntlShape;
}): JSONSchema => ({
  title: 'Template Selector Block',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [],
    },
  ],
  properties: {},
  required: [],
});
interface BlockTemplateSelectorConfig
  extends Omit<BlockConfigBase, 'blockSchema'> {
  blockSchema: typeof TemplateSelectorBlockSchema;
}

export { TemplateSelectorBlockSchema, type BlockTemplateSelectorConfig };
